"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.formatPhone = exports.formatEventViewerDate = exports.zeroPad = void 0;
const zeroPad = (n, a = 2) => `00${n}`.substr(-a);
exports.zeroPad = zeroPad;
const formatEventViewerDate = (date) => {
    const dateObject = new Date(date);
    const hour = dateObject.getHours();
    const minute = dateObject.getMinutes();
    const day = dateObject.getDate();
    const month = dateObject.getMonth();
    const year = dateObject.getFullYear();
    return `${exports.zeroPad(hour)}:${exports.zeroPad(minute)} on ${exports.zeroPad(month + 1)}/${exports.zeroPad(day)}/${year}`;
};
exports.formatEventViewerDate = formatEventViewerDate;
const formatPhone = (phone) => {
    phone.trimLeft().trimRight();
    return phone.substring(0, 3) + '.' + phone.substring(3, 6) + '.' + phone.substring(6, 10);
};
exports.formatPhone = formatPhone;
//# sourceMappingURL=formats.js.map